import moment from 'moment';

function setupAppLocaleData(localeData, messages, cb) {
  moment.locale(localeData.momentLocale);
  const tz = moment.tz.guess();
  cb(
    {
      locale: localeData.locale,
      tz,
    },
    messages.default,
  );
}

export default function loadLocaleData(locale, cb) {
  const needPluralRules = !Intl.PluralRules;
  const needRelativeTimeFormat = !Intl.RelativeTimeFormat;
  let messages;
  const localeData = {
    locale,
    momentLocale: locale.toLowerCase(),
  };

  switch (locale) {
    case 'de':
      require.ensure(
        [
          'moment/locale/de',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/de',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/de',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/de',
        ],
        require => {
          require('moment/locale/de');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/de');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/de');
          }
          messages = require('../bundles/de');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-de',
      );
      break;
    case 'vi':
      require.ensure(
        [
          'moment/locale/vi',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/vi',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/vi',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/vi',
        ],
        require => {
          require('moment/locale/vi');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/vi');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/vi');
          }
          messages = require('../bundles/vi');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-vi',
      );
      break;
    case 'es':
      require.ensure(
        [
          'moment/locale/es',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/es',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/es',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/es',
        ],
        require => {
          require('moment/locale/es');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/es');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/es');
          }
          messages = require('../bundles/es');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-es',
      );
      break;
    case 'fr':
      require.ensure(
        [
          'moment/locale/fr',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/fr',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/fr',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/fr',
        ],
        require => {
          require('moment/locale/fr');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/fr');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/fr');
          }
          messages = require('../bundles/fr');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-fr',
      );
      break;
    case 'it':
      require.ensure(
        [
          'moment/locale/it',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/it',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/it',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/it',
        ],
        require => {
          require('moment/locale/it');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/it');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/it');
          }
          messages = require('../bundles/it');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-it',
      );
      break;
    case 'nl':
      require.ensure(
        [
          'moment/locale/it',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/nl',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/nl',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/nl',
        ],
        require => {
          require('moment/locale/nl');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/nl');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/nl');
          }
          messages = require('../bundles/nl');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-nl',
      );
      break;
    case 'nb':
      require.ensure(
        [
          'moment/locale/it',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/nb',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/nb',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/nb',
        ],
        require => {
          require('moment/locale/nb');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/nb');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/nb');
          }
          messages = require('../bundles/nb');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-nb',
      );
      break;
    case 'ko':
      require.ensure(
        [
          'moment/locale/ko',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/ko',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/ko',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/ko',
        ],
        require => {
          require('moment/locale/ko');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/ko');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/ko');
          }
          messages = require('../bundles/ko');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-ko',
      );
      break;
    case 'zh-CN':
      require.ensure(
        [
          'moment/locale/zh-cn',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/zh',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/zh',
          './moment/moment-timzone-with-data-1970-2030',
          // '../bundles/zh-CN',
        ],
        require => {
          require('moment/locale/zh-cn');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/zh');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/zh');
          }
          messages = require('../bundles/zh-Hans');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-zh-CN',
      );
      break;
    case 'zh-Hans':
      require.ensure(
        [
          'moment/locale/zh-cn',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/zh',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/zh',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/zh-Hans',
        ],
        require => {
          require('moment/locale/zh-cn');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/zh');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/zh');
          }
          messages = require('../bundles/zh-Hans');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-zh-CN',
      );
      break;
    case 'zh-TW':
      require.ensure(
        [
          'moment/locale/zh-tw',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/zh',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/zh',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/it',
        ],
        require => {
          require('moment/locale/zh-tw');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/zh');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/zh');
          }
          messages = require('../bundles/zh-TW');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-zh-TW',
      );
      break;
    case 'en-GB':
      require.ensure(
        [
          'moment/locale/en-gb',
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/en',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/en',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/en-GB',
        ],
        require => {
          require('moment/locale/en-gb');
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/en');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/en');
          }
          messages = require('../bundles/en-GB');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-en-GB',
      );
      break;
    default:
      require.ensure(
        [
          '@formatjs/intl-pluralrules/polyfill',
          '@formatjs/intl-pluralrules/dist/locale-data/en',
          '@formatjs/intl-relativetimeformat/polyfill',
          '@formatjs/intl-relativetimeformat/dist/locale-data/en',
          './moment/moment-timzone-with-data-1970-2030',
          '../bundles/en',
        ],
        require => {
          require('./moment/moment-timzone-with-data-1970-2030');
          if (needPluralRules) {
            require('@formatjs/intl-pluralrules/polyfill');
            require('@formatjs/intl-pluralrules/dist/locale-data/en');
          }
          if (needRelativeTimeFormat) {
            require('@formatjs/intl-relativetimeformat/polyfill');
            require('@formatjs/intl-relativetimeformat/dist/locale-data/en');
          }
          messages = require('../bundles/en');
          setupAppLocaleData(localeData, messages, cb);
        },
        'app-en',
      );
      break;
  }
}



// WEBPACK FOOTER //
// ./src/i18n/localeDataConfig.js